<template>
  <!-- 根据当前路由决定是否显示布局 -->
  <div v-if="showLayout" class="app-container">
    <!-- 侧边栏 -->
    <aside class="sidebar">
      <div class="logo">
        <h1>噗噗云闪仓</h1>
      </div>
      <nav class="menu">
        <el-menu 
            :default-active="activeMenu" 
            class="el-menu-vertical-demo" 
            background-color="#000000" 
            text-color="#ffffff" 
            active-text-color="#ffd04b"
            @select="handleMenuSelect"
          >
            <el-menu-item index="/home">
              <el-icon><House /></el-icon>
              <span>首页</span>
            </el-menu-item>
            <el-sub-menu index="1">
              <template #title>
                <el-icon><Folder /></el-icon>
                <span>仓店管理</span>
              </template>
              <el-menu-item index="/store-management">门店仓管理</el-menu-item>
              <el-menu-item index="/channel-management">渠道店管理</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="2">
              <template #title>
                <el-icon><Goods /></el-icon>
                <span>商品管理</span>
              </template>
              <el-menu-item index="/product-init">总部商品库</el-menu-item>
              <el-menu-item index="/store-products">门店商品</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="3">
              <template #title>
                <el-icon><ShoppingCart /></el-icon>
                <span>采购管理</span>
              </template>
              <el-menu-item index="/procurement/suppliers">供应商管理</el-menu-item>
              <el-menu-item index="/procurement/replenishment">自动补货</el-menu-item>
              <el-menu-item index="/procurement/plans">采购计划</el-menu-item>
              <el-menu-item index="/procurement/single-plans">单一采购计划</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="4">
              <template #title>
                <el-icon><Box /></el-icon>
                <span>仓库管理</span>
              </template>
              <el-menu-item index="/inventory/inbound">入库管理</el-menu-item>
              <el-menu-item index="/inventory/transfer">调拨出库</el-menu-item>
              <el-menu-item index="/inventory/outbound">手工出库</el-menu-item>
              <el-menu-item index="/inventory/stocktake">仓库盘点</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="5">
              <template #title>
                <el-icon><Setting /></el-icon>
                <span>无人仓管理</span>
              </template>
              <el-menu-item index="/unmanned-warehouse">门锁管理</el-menu-item>
              <el-menu-item index="/taobao-orders">淘宝闪购订单</el-menu-item>
              <el-menu-item index="/order-complex">订单复合</el-menu-item>
              <el-menu-item index="/lock-setting">锁设置</el-menu-item>
              <el-menu-item index="/monitor-setting">监控设置</el-menu-item>
            </el-sub-menu>
            <el-menu-item index="/jieshun-sync">
              <el-icon><Refresh /></el-icon>
              <span>街顺数据同步</span>
            </el-menu-item>
          </el-menu>
      </nav>
      <!-- 底部管理员信息 -->
      <div class="admin-info">
        <el-avatar :size="32" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
        <div class="admin-details">
          <div class="admin-name">{{ username || '管理员' }}</div>
          <div class="admin-id" @click="handleLogout">退出登录</div>
        </div>
      </div>
    </aside>
    
    <!-- 主内容区域 -->
    <main class="main-content">
      <router-view />
    </main>
  </div>
  
  <!-- 登录页面不显示布局 -->
  <div v-else>
    <router-view />
  </div>
</template>

<script>
import { ref, onMounted, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Box, Folder, Goods, House, Refresh, Setting, ShoppingCart } from '@element-plus/icons-vue'
import authApi from '@/api/auth'

export default {
  name: 'App',
  components: {
    Folder,
    Goods,
    Setting,
    ShoppingCart,
    Box,
    House,
    Refresh
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const activeMenu = ref('/home')
    const showLayout = ref(true)
    const isNavigating = ref(false)
    const username = ref(localStorage.getItem('username') || '')
    
    // 根据当前路由设置激活菜单和是否显示布局
    const updateActiveMenu = () => {
      const path = route.path
      
      // 登录、忘记密码、H5和拣货页面不显示后台布局
      if (path === '/login' || path === '/forgot-password' || path === '/h5' || path.startsWith('/mobile') || path === '/pick') {
        showLayout.value = false
      } else {
        showLayout.value = true
      }
      
      // 设置激活菜单
      if (path === '/home') {
        activeMenu.value = '/home'
      } else if (path.includes('/store-management')) {
        activeMenu.value = '/store-management'
      } else if (path.includes('/channel-management')) {
        activeMenu.value = '/channel-management'
      } else if (path.includes('/product-management')) {
        activeMenu.value = '/product-init'
      } else if (path.includes('/product-init')) {
        activeMenu.value = '/product-init'
      } else if (path.includes('/store-products')) {
        activeMenu.value = '/store-products'
      } else if (path.includes('/procurement/purchase-list')) {
        activeMenu.value = '/procurement/plans'
      } else if (path.includes('/procurement/suppliers')) {
        activeMenu.value = '/procurement/suppliers'
      } else if (path.includes('/procurement/replenishment')) {
        activeMenu.value = '/procurement/replenishment'
      } else if (path.includes('/procurement/plans')) {
        activeMenu.value = '/procurement/plans'
      } else if (path.includes('/procurement/single-plans')) {
        activeMenu.value = '/procurement/single-plans'
      } else if (path.includes('/inventory/inbound')) {
        activeMenu.value = '/inventory/inbound'
      } else if (path.includes('/inventory/transfer')) {
        activeMenu.value = '/inventory/transfer'
      } else if (path.includes('/inventory/outbound')) {
        activeMenu.value = '/inventory/outbound'
      } else if (path.includes('/inventory/stocktake')) {
        activeMenu.value = '/inventory/stocktake'
      } else if (path.includes('/unmanned-warehouse')) {
        activeMenu.value = '/unmanned-warehouse'
      } else if (path.includes('/taobao-orders')) {
        activeMenu.value = '/taobao-orders'
      } else if (path.includes('/order-complex')) {
        activeMenu.value = '/order-complex'
      } else if (path.includes('/lock-setting')) {
        activeMenu.value = '/lock-setting'
      } else if (path.includes('/monitor-setting')) {
        activeMenu.value = '/monitor-setting'
      } else if (path.includes('/authorize-bind')) {
        activeMenu.value = '/monitor-setting'
      } else if (path.includes('/jieshun-sync')) {
        activeMenu.value = '/jieshun-sync'
      }
    }
    
    // 处理菜单选择
    const handleMenuSelect = (index) => {
      console.log('菜单点击:', index)
      if (index && index.startsWith('/') && !isNavigating.value) {
        isNavigating.value = true
        nextTick(() => {
          setTimeout(() => {
            router.push(index).finally(() => {
              isNavigating.value = false
            })
          }, 100)
        })
      }
    }
    
    // 导航到指定路由
    const navigateTo = (path) => {
      console.log('导航到:', path)
      if (!isNavigating.value) {
        isNavigating.value = true
        router.push(path).finally(() => {
          isNavigating.value = false
        })
      }
    }

    const handleLogout = async () => {
      try {
        await authApi.logout()
      } catch (error) {
        console.error('退出登录失败:', error)
      } finally {
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        router.push('/login')
      }
    }
    
    onMounted(() => {
      updateActiveMenu()
      username.value = localStorage.getItem('username') || ''
    })
    
    // 监听路由变化，更新菜单和布局
    watch(
      () => route.path,
      () => {
        updateActiveMenu()
      }
    )
    
    return {
      activeMenu,
      showLayout,
      handleMenuSelect,
      navigateTo,
      username,
      handleLogout
    }
  }
}
</script>

<style scoped>
.app-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
  min-width: 0;
}

.sidebar {
  width: 200px;
  min-width: 200px;
  flex: 0 0 200px;
  background-color: #000000;
  color: #ffffff;
  display: flex;
  flex-direction: column;
}

.logo {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #333333;
}

.logo h1 {
  margin: 0;
  font-size: 18px;
  color: #ffffff;
}

.menu {
  flex: 1;
  overflow-y: auto;
}

.admin-info {
  padding: 15px;
  display: flex;
  align-items: center;
  border-top: 1px solid #333333;
}

.admin-details {
  margin-left: 10px;
}

.admin-name {
  font-size: 14px;
  font-weight: bold;
}

.admin-id {
  font-size: 12px;
  color: #999999;
  cursor: pointer;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
  background-color: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
}
</style>
